import EyeIcon from './EyeIcon'
import EyeInvisibleIcon from './EyeInvisibleIcon'
import IdCardIcon from './IdCardIcon'
import ClockCircleIcon from './ClockCircleIcon'
import TeamIcon from './TeamIcon'
import CaretDownIcon from './CaretDownIcon'
import PhoneIcon from './PhoneIcon'
import MailIcon from './MailIcon'
import LockIcon from './LockIcon'
import UnlockIcon from './UnlockIcon'
import EditIcon from './EditIcon'
import RefreshIcon from './RefreshIcon'
import CustomerServiceIcon from './CustomerServiceIcon'
import ExpanderIcon from './ExpanderIcon'

export default {
  'eye': EyeIcon,
  'eye-invisible': EyeInvisibleIcon,
  'idcard': IdCardIcon,
  'clock-circle-o': ClockCircleIcon,
  'clock-circle': ClockCircleIcon,
  'team': TeamIcon,
  'caret-down': CaretDownIcon,
  'phone': PhoneIcon,
  'mail': MailIcon,
  'lock': LockIcon,
  'unlock': UnlockIcon,
  'edit': EditIcon,
  'refresh': RefreshIcon,
  'customer-service': CustomerServiceIcon,
  'expander': ExpanderIcon,
}
